declare global {
  interface Window {
    ibinder: any;
  }
}

// Libs
import React from 'react';
import ReactDOM from 'react-dom';

// Utils
import {
  initCallbacksForAppInsights,
  Config,
  CREATE_FEATURE_TOGGLE_MAP,
  EXTRACT_TENANTID_FROM_URL
} from '@ibinder/common-utils';

// Application
import App from './App';

import { getAppSetting } from 'Shared/ApplicationSettings';

declare let __COMMIT_HASH__: string;
const LOGO = `:::'###::::'########::'##::::'##:'####:'##::: ##:
::'## ##::: ##.... ##: ###::'###:. ##:: ###:: ##:
:'##:. ##:: ##:::: ##: ####'####:: ##:: ####: ##:
'##:::. ##: ##:::: ##: ## ### ##:: ##:: ## ## ##:
 #########: ##:::: ##: ##. #: ##:: ##:: ##. ####:
 ##.... ##: ##:::: ##: ##:.:: ##:: ##:: ##:. ###:
 ##:::: ##: ########:: ##:::: ##:'####: ##::. ##:
..:::::..::........:::..:::::..::....::..::::..::`;

console.log(LOGO);
console.log('will boot admins-ui version: ', __COMMIT_HASH__);

// Setup ibinder object
const SET_UP_WINDOW_OBJ = () => {
  // @ts-ignore
  window.ibinder = window.ibinder || {};
  window.ibinder.configCatClient = window.ibinder.configCatClient || {};
};

SET_UP_WINDOW_OBJ();

CREATE_FEATURE_TOGGLE_MAP(
  getAppSetting('REACT_FEAT_TOGGLE_SEVERITY_LOG'),
  getAppSetting('REACT_APP_CONFIG_CAT_FEAT_TOGGLE_KEY'),
  Config.MAIN_CONFIG,
  getAppSetting('REACT_FEAT_TOGGLE_CACHE_TIME')
);
CREATE_FEATURE_TOGGLE_MAP(
  getAppSetting('REACT_FEAT_TOGGLE_SEVERITY_LOG'),
  getAppSetting('REACT_APP_CONFIG_CAT_FEAT_TOGGLE_OPERATIONAL_KEY'),
  Config.OPERATIONAL_CONFIG,
  getAppSetting('REACT_FEAT_TOGGLE_CACHE_TIME')
);

// Application tracking Init
initCallbacksForAppInsights(
  () => getAppSetting('REACT_APP_APPLICATION_INSIGHT_ID'),
  () => localStorage.getItem('userId'),
  () => EXTRACT_TENANTID_FROM_URL(),
  'admins-ui',
  JSON.parse(getAppSetting('REACT_APP_EXCLUDED_APPINSIGHTS_DOMAINS'))
);

ReactDOM.render(<App />, document.getElementById('adminui'));
